<sb-dialog-header>
  <h3 sb-dialog-title>{{ 'Preview template' | translate }}</h3>
  @if (featureFlag.TMP_DOCUMENT_PDF_PREVIEW | featureFlag) {
    <sb-dialog-header-actions>
      @if (preview.hasValue()) {
        <button sb-icon-button [color]="'transparent'" (click)="downloadTemplate()">
          <sb-icon [name]="'download-2-regular'" />
          <span class="sr-only">{{ 'Download preview' | translate }}</span>
        </button>
      }
    </sb-dialog-header-actions>
  }
</sb-dialog-header>

<sb-dialog-content>
  <sb-dialog-sidebar>
    @if (templateContractInfo(); as templateInfo) {
      <div [attr.eSignEnabled]="templateInfo.eSignEnabled">
        @if (templateInfo.eSignEnabled) {
          <h3>{{ 'All set for E-signing!' | translate }}</h3>
          <p>
            {{ 'Your template includes all the required fields to enable E-sign.' | translate }}
          </p>
        } @else {
          <h3>{{ 'Missing field(s) for E-sign' | translate }}</h3>
          <p>
            {{ 'To use the eSign flow, add the missing fields and re-upload the template.' | translate }}
          </p>
          @let missingFields = missingESignFields();
          @if (missingFields.length > 0) {
            <ul class="mt-sm">
              @for (field of missingFields; track field.variable) {
                <li class="flex flex-wrap items-center gap-sm">
                  <sb-field-button [field]="field"></sb-field-button>
                </li>
              }
            </ul>
          }
        }
      </div>
    }
    <h3>{{ 'Matched fields' | translate }}</h3>
    <p>
      {{ 'These fields were recognized and will be filled automatically when you generate a contract.' | translate }}
    </p>
    @if (templateContractInfo()?.variables.length > 0) {
      <ul>
        @for (variable of templateContractInfo()?.variables; track variable) {
          <li>
            <sb-field-button [field]="variable" [isInteractive]="false"></sb-field-button>
          </li>
        }
      </ul>
    } @else {
      <p>
        {{
          'No fields found. Check that your document uses the correct format (e.g., [firstName]).'
            | translate: { firstName: '{first_name}' }
        }}
      </p>
    }
  </sb-dialog-sidebar>
  <section>
    <form sb-dialog-form [formGroup]="form">
      <sb-form-field [errorWhen]="['touched']" [control]="form.controls.title" [label]="'Document name' | translate">
        <input sbInput formControlName="title" />
      </sb-form-field>
    </form>
    @if (featureFlag.TMP_DOCUMENT_PDF_PREVIEW | featureFlag) {
      @switch (preview.status()) {
        @case ('resolved') {
          @if (preview.value(); as file) {
            <sb-pdf-viewer
              class="max-md:h-96 md:min-h-0 md:flex-1"
              [file]="file"
              [label]="'Template preview' | translate"
              [hiddenControls]="hiddenPreviewControls"
            />
          }
        }
        @case ('error') {
          <sb-notice variant="warning">
            <p>
              {{ 'We could not load the preview. You can download the highlighted document instead.' | translate }}
            </p>
            <button sbNoticeAction type="button" (click)="downloadTemplate()">
              {{ 'Download preview' | translate }}
            </button>
          </sb-notice>
        }
        @default {
          <div class="flex items-center justify-center max-md:h-96 md:min-h-0 md:flex-1">
            <sb-spinner [size]="'lg'" [attr.aria-label]="'Loading the preview' | translate" />
          </div>
        }
      }
    } @else {
      <p>
        {{
          "If you'd like to review the uploaded document with all detected variables highlighted—including those that will be replaced and those that are invalid—you can download it below."
            | translate
        }}
      </p>
      <button sb-button [color]="'secondary'" (click)="downloadTemplate()">
        {{ 'Download preview' | translate }}
      </button>
    }
  </section>
</sb-dialog-content>
<sb-dialog-footer>
  <sb-dialog-footer-actions [align]="'end'">
    <button sb-button (click)="deleteUploadedDocument()">
      {{ 'Replace document' | translate }}
    </button>
    <button sb-button [color]="'primary'" (click)="finish()">
      {{ 'Finish' | translate }}
    </button>
  </sb-dialog-footer-actions>
</sb-dialog-footer>
